module.exports = __webpack_public_path__ + "static/js/2.b0d2c237.chunk.worker.js"